import { useQuery } from '@tanstack/react-query';

import { listHardwareDevices } from '@/pages/api/scribeAPI';
import type { HardwareDeviceResponse } from '@/types';
import { reactQueryClient } from '@/utils/reactQueryClient';

export const LIST_HARDWARE_DEVICES = 'listHardwareDevices';

/** Mark the cached linked-device list as stale — triggers refetch if an observer is active. */
export const invalidateListHardwareDevices = async () => {
  await reactQueryClient.invalidateQueries({
    queryKey: [LIST_HARDWARE_DEVICES],
  });
};

export function useQueryListHardwareDevices(enabled: boolean) {
  return useQuery<HardwareDeviceResponse[]>({
    queryKey: [LIST_HARDWARE_DEVICES],
    queryFn: async () => {
      const { data } = await listHardwareDevices();
      return data;
    },
    enabled,
  });
}
